<template>
  <header class="header_wrapper">
    <div class="header_container">
      <div class="header_left">
        <el-popover placement="bottom-start" width="300" popper-class="popover" trigger="hover">
          <div v-if="isChrome">
            <p class="title">你可以通过以下方式收藏轻秒网址，再也不担心找不到啦～</p>
            <ul>
              <li>1、按{{ isMacOs ? `「⌘+D」` : `「Ctrl+D」` }}收藏本站 或 拖动LOGO到书签栏</li>
              <li>2、点击 <span class="line" @click="createFast">创建快捷方式→</span></li>
            </ul>
          </div>
          <div v-else>
            <p>按{{ isMacOs ? `「⌘+D」` : `「Ctrl+D」` }}收藏本站 或 拖动LOGO到书签栏</p>
          </div>
          <router-link to="/" slot="reference">
            <div class="logo_wrapper">
              <img src="@/assets/img/logo.svg" alt="轻秒格式工厂" class="logo" />
              <img src="@/assets/img/logo_1.svg" alt="轻秒格式工厂" class="logo1" />
            </div>
          </router-link>
        </el-popover>
        <NavMenu :menus="menus" />
      </div>
      <div class="header_right">
        <PurchaseButton
          v-if="allCert?.vip === VIP_LEVEL.COUNT_VIP"
          class="purchaseButtonComponent"
          :width="'135px'"
          :height="'44px'"
          :border-radius="'28px'"
          >限时升级 <span class="corner">终身仅39元</span></PurchaseButton
        >
        <PurchaseButton
          v-else-if="
            allCert?.vip !== VIP_LEVEL.COUNT_VIP && allCert?.vip !== VIP_LEVEL.PERMANENT_VIP
          "
          class="purchaseButtonComponent"
          :width="'120px'"
          :height="'44px'"
          :border-radius="'28px'"
          >{{ btnTxt }} <img src="https://res.yunkun.cn/img_geshicn/img/activity.svg" class="activity_img" alt=""
        /></PurchaseButton>
        <div v-if="!isUserLogin" class="loginWrap">
          <LoginButton>登录/注册<img src="@/assets/img/login_tips.svg" class="tips" alt="" /></LoginButton>
        </div>
        <UserInfo v-else />
      </div>
    </div>
  </header>
</template>

<script>
import LoginButton from '@/components/LoginButton/index.vue'
import PurchaseButton from '@/components/PurchaseButton/index.vue'
import NavMenu from '@/components/NavMenu/index.vue'
import UserInfo from '@/components/UserInfo/index.vue'
import { headerMenus } from '../../config/menus.config'
import { mapGetters } from 'vuex'
import { VIP_LEVEL } from '../../config'
import { isChrome } from "@/utils/isChrome";
import { isMacOS } from "@/utils/isMacOS";

export default {
  name: 'Header',
  components: {
    UserInfo,
    NavMenu,
    LoginButton,
    PurchaseButton
  },
  props: {},
  data() {
    return {
      menus: headerMenus,
      deferredPrompt: null,
      listenFunc: () => {},
      isChrome: isChrome(),
      isMacOs: isMacOS(),
    }
  },
  computed: {
    VIP_LEVEL() {
      return VIP_LEVEL
    },
    ...mapGetters(['isLogin']),
    allCert() {
      return this.$store.state.allCert
    },
    btnTxt() {
      if (this.allCert?.vip && this.allCert?.vip !== VIP_LEVEL.NON_VIP) {
        return '续费会员'
      }
      return '开通会员'
    },
    isUserLogin() {
      return this.isLogin
    }
  },
  methods: {
    createFast() {
      // this.deferredPrompt?.prompt()
      this.$store.dispatch('installApp')
    }
  },
  // mounted() {
  //   this.deferredPrompt = null
  //   let that = this
  //   this.listenFunc = e => {
  //     // 阻止浏览器默认行为
  //     e.preventDefault()
  //     // 保存事件以备后用
  //     that.deferredPrompt = e
  //     // 等待用户响应
  //     that.deferredPrompt?.userChoice.then((choiceResult) => {
  //       if (choiceResult.outcome === 'accepted') {
  //         console.log('用户已同意安装');
  //       } else {
  //         console.log('用户拒绝了安装');
  //       }
  //       // 重置 deferredPrompt 变量，以便下次触发安装提示时使用
  //       that.deferredPrompt = null;
  //     });
  //   }
  //   window.addEventListener('beforeinstallprompt', this.listenFunc)
  // },
  // beforeDestroy() {
  //   window.removeEventListener('beforeinstallprompt',this.listenFunc)
  // }
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
